import {
  GetGstrThreeBListPayloadType,
  GetGstrTwoAListPayloadType,
  GetGstrTwoBListPayloadType,
  GetInwardDataPayload,
  GetOutwardDataPayload,
  GstrOnePayload,
  GstrOnehsnWiseCountPayload,
  GstrThreeBInvoiceListPayload,
  PostGstrOneSaveDataType,
  GstrFilingSendOTPPayload,
  PostGstrOneCompleteFilingType,
  RequestGstOtpPayloadType,
  UpdateInwardDataPayload,
  UpdateOutwardDataPayload,
  VerifyGstOtpPayloadType,
  GetGstNumberPayload,
  ApproveGstPayloadType,
  GstCommentPayloadType,
  GstGetAllCommentPayloadType,
  DownloadGST2ADataPayload,
  DownloadGST2BDataPayload,
  PostGstrOneProceedType,
  GstrOneSatusType,
  GetGstrTwoATwoBComparePayloadType,
  ARNNumberPayloadType,
  GstrOneDownloadJsonType,
} from "../commonTypes/gstTypes";
import { getCSRFToken } from "../utils/commonFunctions";
import { getData, postData } from "./apiInstance";
import { AxiosResponse } from "axios";

export async function getOutwardsListApi(
  data: GetOutwardDataPayload
): Promise<AxiosResponse> {
  const {
    token,
    client_code,
    offset,
    limit,
    search_term,
    start_date,
    end_date,
    exports,
    sez,
    sez_tax_payment,
    place_of_supply,
    sales_type,
    sort_by,
    sort_order,
  } = data;
  return getData(`gst-module/outwards/list`, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
    params: {
      client_code,
      offset,
      limit,
      ...(search_term && { search_term }),
      ...(start_date && { start_date }),
      ...(end_date && { end_date }),
      ...(exports && { exports }),
      ...(sez && { sez }),
      ...(sez_tax_payment && { sez_tax_payment }),
      ...(place_of_supply && { place_of_supply }),
      ...(sales_type && { sales_type }),
      ...(sort_by && { sort_by }),
      ...(sort_order && { sort_order }),
    },
  });
}

export async function updateOutwardsListApi(
  data: UpdateOutwardDataPayload
): Promise<AxiosResponse> {
  const { token, client_code, gst_outward_id, data_to_update } = data;

  const finalData = {
    client_code,
    gst_outward_id,
    data_to_update,
  };

  return postData(`gst-module/update/outwards/entry`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function getInwardsListApi(
  data: GetInwardDataPayload
): Promise<AxiosResponse> {
  const {
    token,
    client_code,
    offset,
    limit,
    search_term,
    start_date,
    end_date,
    gstr2a,
    gstr2b,
    seller_type,
    whether_eligible,
    purchase_from_composition_dealer,
    sort_by,
    sort_order,
  } = data;
  return getData(`gst-module/inwards/list`, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
    params: {
      client_code,
      offset,
      limit,
      ...(search_term && { search_term }),
      ...(start_date && { start_date }),
      ...(end_date && { end_date }),
      ...(gstr2a && { gstr2a }),
      ...(gstr2b && { gstr2b }),
      ...(seller_type && { seller_type }),
      ...(whether_eligible && { whether_eligible }),
      ...(purchase_from_composition_dealer && {
        purchase_from_composition_dealer,
      }),
      ...(sort_by && { sort_by }),
      ...(sort_order && { sort_order }),
    },
  });
}

export async function updateInwardsListApi(
  data: UpdateInwardDataPayload
): Promise<AxiosResponse> {
  const { token, client_code, gst_inward_id, data_to_update } = data;

  const finalData = {
    client_code,
    gst_inward_id,
    data_to_update,
  };

  return postData(`gst-module/update/inwards/entry`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function getGstOneListApi(
  data: GstrOnePayload
): Promise<AxiosResponse> {
  const { token, client_code, branch_id, finacial_year, month, gst_number } =
    data;
  return getData(`gst-module/gstr1-details`, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
    params: {
      client_code,
      branch_id,
      financial_year: finacial_year,
      month,
      gst_number,
    },
  });
}

export async function getGstOneInvoiceListApi(
  data: GstrOnePayload
): Promise<AxiosResponse> {
  const {
    token,
    client_code,
    branch_id,
    finacial_year,
    month,
    gstr1_type,
    gst_number,
  } = data;
  return getData(`gst-module/gstr1/invoice/list`, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
    params: {
      client_code,
      branch_id,
      financial_year: finacial_year,
      month,
      gstr1_type,
      gst_number,
    },
  });
}

export async function getGstThreeBInvoiceListAPi(
  data: GstrThreeBInvoiceListPayload
): Promise<AxiosResponse> {
  const {
    token,
    clientCode,
    branchId,
    month,
    gstr3bType,
    finacialYear,
    gst_number,
  } = data;
  const finalParams = {
    client_code: clientCode,
    branch_id: branchId,
    financial_year: finacialYear,
    month,
    gstr3b_type: gstr3bType,
    gst_number,
  };
  return getData(`gst-module/gstr3b/invoice/list`, {
    params: { ...finalParams },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
export async function downloadOutwardsReportsApi(
  data: GetOutwardDataPayload
): Promise<AxiosResponse> {
  const {
    token,
    client_code,
    offset,
    limit,
    search_term,
    start_date,
    end_date,
    exports,
    sez,
    sez_tax_payment,
    place_of_supply,
    sales_type,
    sort_by,
    sort_order,
  } = data;
  return getData(`gst-module/outwards/list/download`, {
    params: {
      client_code,
      offset,
      limit,
      ...(search_term && { search_term }),
      ...(start_date && { start_date }),
      ...(end_date && { end_date }),
      ...(exports && { exports }),
      ...(sez && { sez }),
      ...(sez_tax_payment && { sez_tax_payment }),
      ...(place_of_supply && { place_of_supply }),
      ...(sales_type && { sales_type }),
      ...(sort_by && { sort_by }),
      ...(sort_order && { sort_order }),
    },
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function downloadInwardsReportsApi(
  data: GetInwardDataPayload
): Promise<AxiosResponse> {
  const {
    token,
    client_code,
    offset,
    limit,
    search_term,
    start_date,
    end_date,
    gstr2a,
    gstr2b,
    seller_type,
    whether_eligible,
    purchase_from_composition_dealer,
    sort_by,
    sort_order,
  } = data;
  return getData(`gst-module/inwards/list/download`, {
    params: {
      client_code,
      offset,
      limit,
      ...(search_term && { search_term }),
      ...(start_date && { start_date }),
      ...(end_date && { end_date }),
      ...(gstr2a && { gstr2a }),
      ...(gstr2b && { gstr2b }),
      ...(seller_type && { seller_type }),
      ...(whether_eligible && { whether_eligible }),
      ...(purchase_from_composition_dealer && {
        purchase_from_composition_dealer,
      }),
      ...(sort_by && { sort_by }),
      ...(sort_order && { sort_order }),
    },
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function downloadGST2AReportsApi(
  data: DownloadGST2ADataPayload
): Promise<AxiosResponse> {
  const {
    token,
    client_code,
    data_type,
    gst_number,
    month,
    year,
    fetch_from_gst_portal,
  } = data;
  return getData(`gst/quicko-gst/get/documents/gstr2a/download`, {
    params: {
      client_code,
      data_type,
      gst_number,
      month,
      year,
      fetch_from_gst_portal,
    },
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function downloadGST2BReportsApi(
  data: DownloadGST2BDataPayload
): Promise<AxiosResponse> {
  const { token, client_code, gst_number, month, year, fetch_from_gst_portal } =
    data;
  return getData(`gst/quicko-gst/get/documents/gstr2b/download`, {
    params: {
      client_code,
      gst_number,
      month,
      year,
      fetch_from_gst_portal,
    },
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getGstrOnehsnWiseCountApi(
  data: GstrOnehsnWiseCountPayload
): Promise<AxiosResponse> {
  const { token, client_code, branch_id, month, gst_number } = data;
  return getData(`gst-module/gstr1/hsn-wise/count`, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
    params: {
      client_code,
      branch_id,
      month,
      gst_number,
    },
  });
}

export async function getGstrTreeBListApi(
  data: GetGstrThreeBListPayloadType
): Promise<AxiosResponse> {
  const { token, clientCode, branchId, month, gst_number } = data;
  const finalData = {
    client_code: clientCode,
    branch_id: branchId,
    month,
    gst_number,
  };
  return getData("gst-module/gstr3b-details", {
    params: { ...finalData },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function requestGstrOtpApi(
  data: RequestGstOtpPayloadType
): Promise<AxiosResponse> {
  const { token, gst_number, client_code, gst_username } = data;
  const finalData = {
    gst_username,
    gst_number,
    client_code,
  };
  return postData("quicko-gst/send/otp/request", finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function verifyGstrOtpApi(
  data: VerifyGstOtpPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, gst_number, gst_username, otp } = data;
  const finalData = {
    gst_number,
    client_code,
    gst_username,
    otp,
  };
  return postData("quicko-gst/verify/otp/request", finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function getGstr2aReturnsApi(
  data: GetGstrTwoAListPayloadType
): Promise<AxiosResponse> {
  const {
    token,
    clientCode,
    dataType,
    gstNumber,
    month,
    year,
    fetchFromGstPortal,
  } = data;
  const finalData = {
    client_code: clientCode,
    data_type: dataType,
    gst_number: gstNumber,
    month,
    year,
    fetch_from_gst_portal: fetchFromGstPortal,
  };
  return getData("gst/quicko-gst/get/documents/gstr2a", {
    params: { ...finalData },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
export async function getGstr2a2bCompareApi(
  data: GetGstrTwoATwoBComparePayloadType
): Promise<AxiosResponse> {
  const { token, clientCode, gstNumber, month, year, type } = data;
  const finalData = {
    client_code: clientCode,
    gst_number: gstNumber,
    month,
    year,
    type,
  };
  return getData("gst/compare/gstr-2a/gstr-2b/expense/invoices", {
    params: { ...finalData },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getGstr2bReturnsApi(
  data: GetGstrTwoBListPayloadType
): Promise<AxiosResponse> {
  const { token, clientCode, gstNumber, month, year, fetchFromGstPortal } =
    data;
  const finalData = {
    client_code: clientCode,
    gst_number: gstNumber,
    month,
    year,
    fetch_from_gst_portal: fetchFromGstPortal,
  };
  return getData("gst/quicko-gst/get/documents/gstr2b", {
    params: { ...finalData },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function postGstrOneFilingSaveDataApi(
  data: PostGstrOneSaveDataType
): Promise<AxiosResponse> {
  const { token, gst_number, client_code, year, month } = data;
  const finalData = {
    gst_number,
    client_code,
    year,
    month,
  };
  return postData("gst/quicko-gst/gstr1/save/data", finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function postGstrOneFilingResetSaveDataApi(
  data: PostGstrOneSaveDataType
): Promise<AxiosResponse> {
  const { token, gst_number, client_code, year, month } = data;
  const finalData = {
    gst_number,
    client_code,
    year,
    month,
  };
  return postData("gst/quicko-gst/gstr1/reset/save/data", finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function postGstrThreeFillingMappingApi(
  data: PostGstrOneSaveDataType
): Promise<AxiosResponse> {
  const { token, gst_number, client_code, year, month } = data;
  const finalData = {
    gst_number,
    client_code,
    year,
    month,
  };
  return postData("gst/gstr/map/gstr3b/data", finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

// export async function gstOneFilingSendOTPApi(
//   data: GstrFilingSendOTPPayload
// ): Promise<AxiosResponse> {
//   const { token, gstin, client_code, year, month } = data;
//   const finalData = {
//     gstin,
//     client_code,
//     year,
//     month,
//   };

//   return getData("gst/quicko-gst/gstr1/proceed/file/otp/request", {
//     params: { ...finalData },
//     headers: {
//       "Content-Type": "application/json",
//       "user-token": token,
//     },
//   });
// }

export async function postOneFilingSendOTPApi(
  data: GstrFilingSendOTPPayload
): Promise<AxiosResponse> {
  const {
    token,
    client_code,

    gst_number,
    gstr_type,
    pan_number,
  } = data;
  const finalData = {
    client_code,

    gst_number,
    gstr_type,
    pan_number,
  };
  return postData("quicko-gst/send/evc-otp/request", finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function postGstOneCompleteFilingApi(
  data: PostGstrOneCompleteFilingType
): Promise<AxiosResponse> {
  const { token, gst_number, client_code, otp, month, year, pan_number } = data;
  const finalData = {
    gst_number,
    client_code,
    otp,
    month,
    year,
    pan_number,
  };
  return postData("gst/quicko-gst/gstr1/file", finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function postGstOneProceedFilingApi(
  data: PostGstrOneProceedType
): Promise<AxiosResponse> {
  const {
    token,
    gst_number,
    client_code,
    year,
    month,
    gstr_type,
    is_nil,
    is_gst_summary_fetched,
  } = data;
  const finalData = {
    gst_number,
    client_code,
    year,
    month,
    gstr_type,
    is_nil,
    is_gst_summary_fetched,
  };
  return postData("gst/quicko-gst/gstr1/proceed/file/get/summary", finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function getGstNumberListApi(
  data: GetGstNumberPayload
): Promise<AxiosResponse> {
  const { token, client_code } = data;
  const finalData = {
    client_code,
  };
  return getData("invoice-generation/address/unique/gst/list", {
    params: { ...finalData },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function approveGstApi(
  payload: ApproveGstPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, gstin, financial_year, gst_form_type, month } =
    payload;

  let finalData = {
    client_code,
    gstin,
    financial_year,
    gst_form_type,
    month,
  };

  return await postData(`gst/gstr/approval/add`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function gstPostComment(
  payload: GstCommentPayloadType
): Promise<AxiosResponse> {
  const {
    token,
    client_code,
    comment,
    financial_year,
    gst_form_type,
    gstin,
    month,
  } = payload;

  let finalData = {
    client_code,
    comment,
    financial_year,
    gst_form_type,
    gstin,
    month,
  };

  return await postData(`gst/gstr/comments/add`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function gstGetAllCommentApi(
  data: GstGetAllCommentPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, financial_year, gst_form_type, gstin, month } =
    data;
  const finalData = {
    client_code,
    financial_year,
    gst_form_type,
    gstin,
    month,
  };
  return getData("gst/gstr/comments/details", {
    params: { ...finalData },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
export async function GstrOneFilingSatusApi(
  data: GstrOneSatusType
): Promise<AxiosResponse> {
  const { token, client_code, month, gst_number, year } = data;
  const finalData = {
    client_code,
    month,
    gst_number,
    year,
  };
  return getData("gst/quicko-gst/gstr1/get/filing/status", {
    params: { ...finalData },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function postARNNumberApi(
  data: ARNNumberPayloadType
): Promise<AxiosResponse> {
  const {
    token,
    client_code,
    acknowledgement_number,
    gstin,
    gstr_type,
    month,
    year,
  } = data;
  const finalData = {
    client_code,
    acknowledgement_number,
    gstin,
    gstr_type,
    month,
    year,
  };
  return postData("gst/gstr/acknowledgement-number/add", finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function gstrOneDownloadJsonApi(
  data: GstrOneDownloadJsonType
): Promise<AxiosResponse> {
  const { token, client_code, month, gst_number, year } = data;
  const finalData = {
    client_code,
    year,
    month,
    gst_number,
  };
  return getData("gst/quicko-gst/gstr1/save/json/payload/download", {
    params: { ...finalData },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
